module.exports = __webpack_public_path__ + "0f23a15a4960d6a70423aaa328cf8624.svg";